import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubbleText6: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bubble-text-6, message, chat"} maskId="square-filled-radius-0-stroke-1-IconBubbleText6"><path fillRule="evenodd" clipRule="evenodd" d="M2 8.5C2 5.46243 4.46243 3 7.5 3H16.5C19.5376 3 22 5.46243 22 8.5V15.5C22 18.5376 19.5376 21 16.5 21H2V8.5ZM8 9V10H16V9H8ZM8 14V15H13V14H8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBubbleText6;
